<template>
  <div class="verification-step">
    <h2>Verify Your {{ type === 'phone' ? 'Phone Number' : 'Email Address' }}</h2>
    <form @submit.prevent="handleSubmit">
      <!-- Hidden username field to help browser autocomplete and prevent interference -->
      <input type="text" name="username" :value="target" style="display:none" autocomplete="username">
      
      <p>A verification code has been sent to:</p>
      <p><strong>{{ target }}</strong></p>
      
      <div v-if="error" class="error-message">{{ error }}</div>
      
      <div class="form-group">
        <label for="verification-code">Code:</label>
        <input 
          id="verification-code" 
          v-model="code" 
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          required 
          :disabled="loading"
          ref="codeInput"
          autocomplete="one-time-code"
        />
      </div>

      <div class="button-row">
        <button type="submit" class="user-modal-submit-btn blue" :disabled="loading || !code">
          {{ loading ? 'Confirming...' : 'Confirm ' + (type === 'phone' ? 'Phone' : 'Email') }}
        </button>
        <button v-if="showBack" type="button" class="user-modal-cancel-btn" @click="$emit('back')" :disabled="loading">
          Back
        </button>
        <button v-if="showSkip" type="button" class="user-modal-cancel-btn" @click="$emit('skip')" :disabled="loading">
          Skip
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'VerificationStep',
  props: {
    type: {
      type: String,
      default: 'email' // 'email' or 'phone'
    },
    target: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showSkip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      code: ''
    };
  },
  methods: {
    handleSubmit() {
      if (this.code) {
        this.$emit('confirm', {
          code: this.code,
          type: this.type
        });
      }
    },
    reset() {
      this.code = '';
    }
  },
  watch: {
    target() {
      this.reset();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.codeInput) {
        this.$refs.codeInput.focus();
      }
    });
  }
};
</script>

<style scoped>
.verification-step {
  width: 100%;
}
.button-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
}
</style>
